<section style="height: auto;" translate="no">
  <nav>
    <ol class="divbusca">
      <div class="div_busca_orientacao">
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="regiao" class="form-label">Região:</label>
          </div>
          <div class="tdCampo">
            <select (change)="onSelecionar(mySelectFiltroRegiao.value)" #mySelectFiltroRegiao name="select"
              aria-placeholder="Regiao" class="form-select">
              <option value="">Todos</option>
              <option *ngFor="let objeto of listaRegiao" value={{objeto.id}}>{{objeto.descricao}}</option>

            </select>
          </div>
        </div>
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="posto" class="form-label">Posto:</label>
          </div>
          <div class="tdCampo">
            <app-multiple-selection-select-all [lista]="listaPostos" [width]="larguraTela/3.5"
              [regiaoSelecionada]="RegiaoSelecionada"
              (infoClicada)="processarInfo($event)"></app-multiple-selection-select-all>
          </div>
        </div>
        <div class="item_pesquisa">
          <div class="tdTitilo">
            <label for="posto" class="form-label">Período da pesquisa:</label>
          </div>
          <div class="tdCampo">
            <div style="height: 34px;">
              <mat-form-field style="height: 63px;">
                <mat-date-range-input [rangePicker]="picker">
                  <input [(ngModel)]="filtroDataInicio" matStartDate placeholder="Data de Início">
                  <input [(ngModel)]="filtroDataFim" matEndDate placeholder="Data Fim">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="tdTitilo">
          <button class="btn btn-primary btnpesquisa" (click)="filtrarPesquisa()" id="class-button" type="submit">Pesquisar</button>
        </div>
      </div>
    </ol>
  </nav>
</section>
<section translate="no">
  <section style="height: auto;">
    <nav>
      <ol class="cd-breadcrumb custom-separator">
        <table>
          <tbody>
            <tr>
              <td class="nomeTela">
                Relatório de Incidência
              </td>
            </tr>
          </tbody>
        </table>
      </ol>
    </nav>
  </section>
  @if (SemDados == true) {
  <h4 class="class-h4">Não exite dados para serem mostrados</h4>
  }
  <div class="div_buttons">
    <button type="button" (click)="exportTableToPDF()" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar PDF<i class="fas fa-file-pdf fa-2xl" style="margin-left: 10px;"></i>
    </button>
    <button (click)="exportTableToExcel()" type="button" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar Excel
      <i class="fas fa-file-excel fa-2xl" style="margin-left: 10px;"></i>
    </button>

    <button (click)="exportTableToExcelInLine()" type="button" class="btn btn-secondary" style="margin-right: 10px;">
      Exportar CSV
      <i class="fas fa-file-csv fa-2xl" style="margin-left: 10px;"></i>
    </button>
  </div>
  <div class="tabela-wrapper">
  <div class="style-tabela">
    <table id="table1" border="0" cellpadding="0" cellspacing="0" #table1>
      <tbody>
        <tr>
          <th class="tituloTabela" (click)="ordenarPorColuna('posto')" style="cursor: pointer;">
            Posto
            <span>
              {{currentSortField === 'posto'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
            </span>
          </th>
          <th class="tituloTabela" (click)="ordenarPorColuna('fila')" style="cursor: pointer;">
            Fila
            <span>
              {{currentSortField === 'fila'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
            </span>
          </th>
          <th class="tituloTabela" (click)="ordenarPorColuna('dataInicio')" style="cursor: pointer;">
            Data Início / Hora
            <span>
              {{currentSortField === 'dataInicio'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
            </span>
          </th>
          <th class="tituloTabela" (click)="ordenarPorColuna('dataFim')" style="cursor: pointer;">
            Data Fim / Hora
            <span>
              {{currentSortField === 'dataFim'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
            </span>
          </th>
          <th class="tituloTabela" (click)="ordenarPorColuna('tempo')" style="cursor: pointer;">
            Tempo
            <span>
              {{currentSortField === 'tempo'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
            </span>
          </th>
          <th class="tituloTabela" (click)="ordenarPorColuna('cidadao')" style="cursor: pointer;">
            Cidadão na Espera
            <span>
              {{currentSortField === 'cidadao'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
            </span>
          </th>
          <th class="tituloTabela" (click)="ordenarPorColuna('pontos')" style="cursor: pointer;">
            Pontos Abertos           
              <span>
                {{currentSortField === 'pontos'? (sortDirection === 'asc' ? '▲' : '▼'): '⇅'}}
              </span>
          </th>
        </tr>
        @for(item of listaIndPosto; track listaIndPosto; let indexp = $index){
        @if(item.indicadorAlertaPermanencia != undefined){
        <tr>
          <th [attr.rowspan]="item.indicadorAlertaPermanencia.length*2">{{item.descricao}}</th>
          <td rowspan="2">{{item.indicadorAlertaPermanencia[0].descFila}}</td>
          <td>{{dateTimeFormatPipe.transform(item.indicadorAlertaPermanencia[0].dataInicio)}}</td>
          <td>{{dateTimeFormatPipe.transform(item.indicadorAlertaPermanencia[0].data_fim)}}</td>
          <td>{{timeFormatPipe.transform((item.indicadorAlertaPermanencia[0].tempo))}}</td>
          <td>{{item.indicadorAlertaPermanencia[0].qtdCidadaoEmEspera}}</td>
          <td>{{item.indicadorAlertaPermanencia[0].qtdPontosAbertos}}</td>
        </tr>
        <tr>
          @if(item.indicadorAlertaPermanencia[0].status === StatusIndicadorAlerta.AO_INCLUIR)
          {
          <td colspan="5" class="StatusAoIncluir">Status: Justificativa Pendente</td>
          }
          @if(item.indicadorAlertaPermanencia[0].status === StatusIndicadorAlerta.PEDENTE_POSTO)
          {
          <td colspan="5" class="StatusPendentePosto">Status: Pendente com Posto</td>
          }
          @if(item.indicadorAlertaPermanencia[0].status === StatusIndicadorAlerta.PENDENTE_VALIDACAO &&
          item.indicadorAlertaPermanencia[0].mensagens != undefined)
          {
          <td class="StatusPendenteValidacao">Status: Pendente Validação</td>
          <td colspan="4" class="StatusPendenteValidacao">
            {{item.indicadorAlertaPermanencia[0].mensagens[item.indicadorAlertaPermanencia[0].mensagens.length -
            1].mensagem}}</td>
          }
          @if(item.indicadorAlertaPermanencia[0].status === StatusIndicadorAlerta.FECHADO &&
          item.indicadorAlertaPermanencia[0].mensagens != undefined &&
          item.indicadorAlertaPermanencia[0].mensagens.length != 0)
          {
          <td class="StatusEncerrado">Status: Encerrado</td>
          <td colspan="4" class="StatusEncerrado">
            {{item.indicadorAlertaPermanencia[0].mensagens[item.indicadorAlertaPermanencia[0].mensagens.length -
            1].mensagem}}</td>
          }

        </tr>
        @for(itemFila of item.indicadorAlertaPermanencia; track itemFila; let indexf = $index){
        @if(indexf != 0){
        <tr>
          <td rowspan="2">{{itemFila.descFila}}</td>
          <td>{{dateTimeFormatPipe.transform(itemFila.dataInicio)}}</td>
          <td>{{dateTimeFormatPipe.transform(itemFila.data_fim)}}</td>
          <td>{{timeFormatPipe.transform(itemFila.tempo)}}</td>
          <td>{{itemFila.qtdCidadaoEmEspera}}</td>
          <td>{{itemFila.qtdPontosAbertos}}</td>
        </tr>
        <tr>
          @if(itemFila.status === StatusIndicadorAlerta.AO_INCLUIR)
          {
          <td colspan="5" class="StatusAoIncluir">Status: Justificativa Pendente</td>
          }
          @if(itemFila.status === StatusIndicadorAlerta.PEDENTE_POSTO)
          {
          <td colspan="5" class="StatusPendentePosto">Status: Pendente com Posto</td>
          }
          @if(itemFila.status === StatusIndicadorAlerta.PENDENTE_VALIDACAO && itemFila.mensagens != undefined)
          {
          <td class="StatusPendenteValidacao">Status: Pendente Validação</td>
          <td colspan="4" class="StatusPendenteValidacao" style="font-weight: bold !important">
            {{itemFila.mensagens[itemFila.mensagens.length - 1].mensagem}}
          </td>
          }
          @if(itemFila.status === StatusIndicadorAlerta.FECHADO && itemFila.mensagens != undefined &&
          itemFila.mensagens.length != 0)
          {
          <td class="StatusEncerrado">Status: Encerrado</td>
          <td colspan="4" class="StatusEncerrado" style="font-weight: bold;">
            {{itemFila.mensagens[itemFila.mensagens.length - 1].mensagem}}</td>
          }
        </tr>
        }
        }
        }
        }
      </tbody>
    </table>
  </div>
</div>